import { render, staticRenderFns } from "./AppNotOpen.vue?vue&type=template&id=51defad8&scoped=true&"
import script from "./AppNotOpen.vue?vue&type=script&lang=js&"
export * from "./AppNotOpen.vue?vue&type=script&lang=js&"
import style0 from "./AppNotOpen.vue?vue&type=style&index=0&id=51defad8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51defad8",
  null
  
)

export default component.exports